import {invalidateOnSuccess, metadaApi} from '@dms/api/base';

import {
  GetDiscountApplicationMethodApiResponse,
  GetDiscountApplicationMethodApiResponseSchema,
  UpdateDiscountApplicationMethodApiArg,
  UpdateDiscountApplicationMethodApiArgSchema,
  UpdateDiscountApplicationMethodApiResponse,
  UpdateDiscountApplicationMethodApiResponseSchema,
} from './types';

export const metadaDiscountApplicationMethodApi = metadaApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getDiscountApplicationMethod: build.query<GetDiscountApplicationMethodApiResponse, void>({
      query: () => ({
        url: `/core/v1/discount-application-method`,
      }),
      providesTags: ['discountApplicationMethod'],
      extraOptions: {
        responseSchema: GetDiscountApplicationMethodApiResponseSchema,
      },
    }),
    updateDiscountApplicationMethod: build.mutation<
      UpdateDiscountApplicationMethodApiResponse,
      UpdateDiscountApplicationMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/discount-application-method`,
        method: 'PUT',
        body: queryArg,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(['discountApplicationMethod']),
      extraOptions: {
        requestSchema: UpdateDiscountApplicationMethodApiArgSchema,
        responseSchema: UpdateDiscountApplicationMethodApiResponseSchema,
      },
    }),
  }),
});

export const {useGetDiscountApplicationMethodQuery, useUpdateDiscountApplicationMethodMutation} =
  metadaDiscountApplicationMethodApi;
